<template>
  <div class="tv-channel-selection">
    <p>Gekozen zenders:</p>
    <div
      v-auto-animate
      class="selected-channels"
    >
      <div
        v-for="channel in selectedChannels"
        :key="channel.slug"
        class="selected-channel"
      >
        <img
          :src="channel.logo"
          alt="channel.name"
          height="24"
          width="32"
        >
        <div>
          {{ channel.name }}
        </div>
        <div
          class="remove-icon"
          @click="removeSelected(channel.slug)"
        >
          <Icon
            icon="x-fa-times"
            size="sm"
          />
        </div>
      </div>
      <div
        v-if="!Object.keys(selectedChannels).length > 0"
        class="notice"
      >
        <p>Geen zenders geselecteerd.</p>
      </div>
    </div>
    <TextInput
      v-model="searchQuery"
      label="Zoek naar zenders"
      placeholder="Begin met typen om zenders te zoeken"
      @input="searchChannels(searchQuery)"
    />

    <div
      v-auto-animate
      class="select-list"
    >
      <CheckboxInput
        v-for="channel in filteredChannels"
        :id="`channel-${channel.slug}`"
        :key="channel.slug"
        v-model="localChannels"
        :value="channel.slug"
        @change="addToSelectedChannels($event, channel)"
      >
        {{ channel.name }}
      </CheckboxInput>
      <div
        v-if="filteredChannels.length === 0 && searchQuery.length < 3"
        class="notice"
      >
        <p>Vul minimaal 3 tekens in om te zoeken naar zenders.</p>
      </div>
      <div
        v-else-if="filteredChannels.length === 0 && searchQuery.length >= 3"
        class="notice"
      >
        <p>Geen zenders gevonden</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from 'axios';
import { onMounted, watch, ref } from 'vue';
import { internetApiUrl } from '../../../../../assets/js/helpers/comparison-url';
import TextInput from '../../../../vue-elements/input/TextInput.vue';
import CheckboxInput from '../../../../vue-elements/input/CheckboxInput.vue';
import Icon from '../../../../vue-elements/icon/Icon.vue';

const props = defineProps({
    tvChannels: {
        type: Array,
        default: () => [],
    },
});

const emit = defineEmits(['updateLabel', 'update:tvChannels']);

const searchQuery = ref('');
const localChannels = ref([]);
const channelData = ref([]);
const filteredChannels = ref([]);
const loading = ref(false);
const channelsLoaded = ref(false);
const selectedChannels = ref({});

const addToSelectedChannels = (event, channel) => {
    if (event.target.checked) {
        selectedChannels.value[channel.slug] = channel;
    } else if (selectedChannels.value[channel.slug]) {
        delete selectedChannels.value[channel.slug];
    }
};

const removeSelected = (slug) => {
    delete selectedChannels.value[slug];
    // Remove slug from localChannels array
    localChannels.value = localChannels.value.filter((channel) => channel !== slug);
};
const updateFromValue = () => {
    if (!channelsLoaded.value) {
        return;
    }

    if (props.tvChannels && Array.isArray(props.tvChannels)) {
        localChannels.value = props.tvChannels;

        props.tvChannels.forEach((value) => {
            const newChannels = channelData.value.filter((channel) => channel.slug === value);

            if (newChannels.length === 1) {
                selectedChannels.value[newChannels[0].slug] = newChannels[0];
            }
        });
    }
};

const updateChannels = () => {
    loading.value = true;

    axios
        .get(`${internetApiUrl()}/v1/tv-channels/noQSjwXdOA4tAZGQ-155`)
        .then((response) => {
            channelsLoaded.value = false;
            channelData.value = [];

            response.data.categories.forEach((category) => {
                category.channels.forEach((channel) => {
                    channelData.value.push(channel);
                });
            });

            channelsLoaded.value = true;
            loading.value = false;

            updateFromValue();
        });
};

const searchChannels = (text) => {
    if (text.length < 3) {
        filteredChannels.value = [];
        return;
    }
    filteredChannels.value = channelData.value.filter((channel) => channel.name
        .toString()
        .toLowerCase()
        .indexOf(text.toLowerCase()) >= 0);
};

watch(localChannels, (newValue) => {
    emit('update:tvChannels', newValue);
    emit('updateLabel', Object.entries(selectedChannels.value).map((channel) => channel[1].name));
});

onMounted(() => {
    updateChannels();
});

</script>

<style lang="scss">
@use 'assets/scss/all.scss' as *;

.tv-channel-selection {
  .selected-channels {
    @include flex-row-start;

    flex-wrap: wrap;
    gap: 12px;
    padding-bottom: 16px;

    min-height: 64px;

  }

  .selected-channel {
    display: grid;
    grid-template-columns: 32px auto 24px;
    align-items: center;
    gap: 4px;
    padding: 8px;
    background-color: $background-default;
    border-radius: 10px;
    border: 1px solid $text-subtle;

    color: $text-subtle;

    img {
      object-fit: contain;
    }
  }

  .remove-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: $text-subtle;

    .icon-element {
      background-color: currentColor;
    }
  }

  .select-list {
    min-height: 64px;
    margin-top: 16px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;

    max-height: 80px;
    overflow: auto;
  }

  .notice {
    font-style: italic;
    color: $text-subtle;
  }
}
</style>
